<div class="right-panel" [class.visible]="visible">
  <iframe 
    src="about:blank" 
    frameborder="0" 
    width="100%" 
    height="100%"
    [src]="iframeSrc">
  </iframe>
</div>
